export function getCheckoutMethodAvailability(user, context, method) {
  return (
    user?.payment_availability?.checkout?.[context]?.[method] || {
      supported: true,
      reason: null,
    }
  );
}

export function getCountryPayoutAvailability(earnings, path) {
  const segments = String(path || "").split(".").filter(Boolean);
  let current = earnings?.countryMethodAvailability;

  for (const segment of segments) {
    current = current?.[segment];
  }

  return (
    current || {
      supported: true,
      reason: null,
    }
  );
}

export function firstSupportedMethod(methodEntries, fallback = "") {
  const match = methodEntries.find((entry) => entry?.availability?.supported);
  return match?.code || fallback;
}
